import { formatDate } from "../../utils/date";
import { TimeAgo } from "../TimeAgo/TimeAgo";

export function DatetimeWithRelative({
   datetime,
   showText = true,
   ...props
}) {
   return (
      <div className='flex flex-row items-center gap-1!'>
         <span>{formatDate(new Date(datetime), true)}</span>
         <span className='text-xs! opacity-60!'>
            (<TimeAgo date={datetime} simple={true} showText={showText} />)
         </span>
      </div>
   );
}